export default __webpack_public_path__ + "static/media/Pretendard-ExtraLight.ff5e73a9.woff";